import { observable } from 'mobx';
import { persist } from 'mobx-persist';

export default class Person {
  @persist
  @observable
  id;

  @persist
  @observable
  lastname;

  @persist
  @observable
  firstname;

  @persist
  @observable
  email;

  constructor({ id, lastname = '', firstname = '', email = '' }) {
    this.id = id;
    this.lastname = lastname;
    this.firstname = firstname;
    this.email = email;
  }
}



// WEBPACK FOOTER //
// ./src/models/Person.js